import { LogoMark } from "@/components/common/logo";

export function FullPageLoader({ label = "Loading your orbit…" }: { label?: string }) {
  return (
    <div className="grid min-h-dvh place-items-center bg-background px-6">
      <div className="flex flex-col items-center gap-4" role="status" aria-live="polite">
        <LogoMark className="size-10 animate-pulse-soft text-brand" />
        <p className="text-sm text-muted-foreground">{label}</p>
      </div>
    </div>
  );
}
